import { render, staticRenderFns } from "./DataReport.vue?vue&type=template&id=82b18982&scoped=true"
import script from "./DataReport.vue?vue&type=script&lang=js"
export * from "./DataReport.vue?vue&type=script&lang=js"
import style0 from "./DataReport.vue?vue&type=style&index=0&id=82b18982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b18982",
  null
  
)

export default component.exports